module.exports = __webpack_public_path__ + "img/wechat-tabs4.d8b5f700.png";